import styled, { css } from "styled-components";


const styles = {
    "LoadingDiv": styled.div`
      background-color: #000;
      opacity: 0.3;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;
    `,
    /* HTML: <div class="loader"></div> */
    "Loader": styled.div`
    width: 100px;
    padding: 8px;
    aspect-ratio: 1;
    border-radius: 50%;
    background: #fff;
    --_m: 
      conic-gradient(#0000 10%,#000),
      linear-gradient(#000 0 0) content-box;
    -webkit-mask: var(--_m);
            mask: var(--_m);
    -webkit-mask-composite: source-out;
            mask-composite: subtract;
    animation: l3 1s infinite linear;
  }
  @keyframes l3 {to{transform: rotate(1turn)}}
    `
}

export default styles